import { Modifier, State } from "@popperjs/core"
import { SxProps } from "@tm/components"
import { useLayoutEffect, useMemo, useRef, useState } from "react"

export function useAutoCompleteStyles() {
    const formGroupRef = useRef<HTMLElement | null>(null)
    const [autoCompleteSx, setAutoCompleteSx] = useState<SxProps>()

    useLayoutEffect(() => {
        const node = formGroupRef.current

        if (!node) {
            return
        }

        const updateAutoCompleteStyles = () => {
            const { width } = node.getBoundingClientRect()
            const left = node.offsetLeft

            setAutoCompleteSx({
                width: `${width}px !important`,
                left: `${left}px !important`,
            })
        }

        updateAutoCompleteStyles()

        const observer = new ResizeObserver(() => {
            updateAutoCompleteStyles()
        })
        observer.observe(node)

        return () => {
            observer.disconnect()
        }
    }, [])

    const autoCompleteModifiers: Partial<Modifier<unknown, object>>[] | undefined = useMemo(
        () => [
            {
                name: "resetTranslateX",
                enabled: true,
                phase: "beforeWrite",
                fn: ({ state }: { state: State }) => {
                    // Set transform translate x value to 0 to center the suggestions shown in the popper component
                    const { transform } = state.styles.popper
                    const CSSMatrix = window.DOMMatrix || window.WebKitCSSMatrix
                    const transformMatrix = new CSSMatrix(transform === "none" ? undefined : transform)
                    transformMatrix.m41 = 0
                    // eslint-disable-next-line no-param-reassign
                    state.styles.popper.transform = transformMatrix.toString()
                },
            },
        ],
        []
    )

    return { formGroupRef, autoCompleteSx, autoCompleteModifiers }
}
